const MDB = window.MDB || {};

//Expose our 'old' global MDB object as a module
export default MDB;